import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TextMaskModule } from 'angular2-text-mask';

import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

import { SharedModule } from '../shared.module';
import { CardsModule } from '../cards/cards.module';
import { ScrollingModule } from '../scrolling/scrolling.module';

import { InputMaskDirective } from './input-mask.directive';
import { DragAndDropFileDirective } from './drag-and-drop-file.directive';
import { ReactiveRequiredDirective } from './reactive-required.directive';
import { UploadBoxComponent } from './upload-box/upload-box.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { StudentsSelectorComponent } from './students-selector/students-selector.component';
import { StudentsClassSelectorComponent } from './students-class-selector/students-class-selector.component';
import { ThemeSelectorComponent } from './theme-selector/theme-selector.component';
import { ParentTaskSelectorComponent } from './parent-task-selector/parent-task-selector.component';
import { TeachersSelectorComponent } from './teachers-selector/teachers-selector.component';
import { SchoolClassCtrlComponent } from './school-class-ctrl/school-class-ctrl.component';
import { PartnerCtrlComponent } from './partner-ctrl/partner-ctrl.component';
import { SchoolsListCtrlComponent } from './schools-list-ctrl/schools-list-ctrl.component';
import { NumbersOnlyDirective } from './numbers-only.directive';
import { ClassesBySchoolsSelectorComponent } from './classes-by-schools-selector/classes-by-schools-selector.component';
import { ThemeFiltersComponent } from './theme-filters/theme-filters.component';


@NgModule({
  declarations: [
    InputMaskDirective,
    ContactFormComponent,
    DragAndDropFileDirective,
    ReactiveRequiredDirective,
    UploadBoxComponent,
    StudentsSelectorComponent,
    StudentsClassSelectorComponent,
    ThemeSelectorComponent,
    ParentTaskSelectorComponent,
    TeachersSelectorComponent,
    SchoolClassCtrlComponent,
    PartnerCtrlComponent,
    SchoolsListCtrlComponent,
    NumbersOnlyDirective,
    ClassesBySchoolsSelectorComponent,
    ThemeFiltersComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    SharedModule,
    TextMaskModule,
    CardsModule,
    ScrollingModule,
    RouterModule
  ],
  exports: [
    EditorModule,
    TextMaskModule,
    InputMaskDirective,
    ContactFormComponent,
    DragAndDropFileDirective,
    ReactiveRequiredDirective,
    UploadBoxComponent,
    StudentsSelectorComponent,
    StudentsClassSelectorComponent,
    ThemeSelectorComponent,
    ParentTaskSelectorComponent,
    TeachersSelectorComponent,
    SchoolClassCtrlComponent,
    PartnerCtrlComponent,
    SchoolsListCtrlComponent,
    NumbersOnlyDirective,
    ClassesBySchoolsSelectorComponent,
    ThemeFiltersComponent,
  ],
  providers: [
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }
  ]
})
export class FormUtilitiesModule { }
